var r=function(r){return r.replace(/^\/|\/$/g,"").split("/")};export{r as getPathSegments};
//# sourceMappingURL=index.js.map
